import { render } from "./AdminCampaignDrafts.vue?vue&type=template&id=8c7bedea&scoped=true"
import script from "./AdminCampaignDrafts.vue?vue&type=script&lang=js"
export * from "./AdminCampaignDrafts.vue?vue&type=script&lang=js"

import "./AdminCampaignDrafts.vue?vue&type=style&index=0&id=8c7bedea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7bedea"]])

export default __exports__